
import { IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem } from '@ionic/vue';

export default {
  components: {
    IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem
  }
}
